import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { ArrowRight } from 'lucide-react';

export const ServiceCard = ({ icon: Icon, title, description, link = '/services' }) => {
  return (
    <Card className="gov-card h-100">
      <Card.Body className="d-flex flex-column p-4">
        <div className="service-icon-box">
          <Icon size={28} />
        </div>
        <h3 style={{ 
          fontSize: '1.125rem', 
          fontWeight: '600', 
          marginBottom: '0.75rem',
          color: 'hsl(var(--foreground))'
        }}>
          {title}
        </h3>
        <p style={{ 
          fontSize: '0.875rem', 
          color: 'hsl(var(--muted-foreground))',
          flex: 1,
          marginBottom: '1rem'
        }}>
          {description}
        </p>
        <Link 
          to={link}
          className="d-flex align-items-center gap-1 mt-auto"
          style={{ 
            fontSize: '0.875rem', 
            fontWeight: '500',
            color: 'hsl(var(--primary))',
            textDecoration: 'none'
          }}
        >
          Learn More
          <ArrowRight size={16} />
        </Link>
      </Card.Body>
    </Card>
  );
};
